import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ffd4b722"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-top" }
const _hoisted_2 = { class: "main_title" }
const _hoisted_3 = { class: "header-left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow_b",
  src: "/assets/icon/btn_back.png",
  srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x"
}, null, -1))
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "header-right" }
const _hoisted_7 = {
  key: 0,
  class: "star",
  src: "/assets/icon/star_s.png",
  srcset: "/assets/icon/star_s@2x.png 2x,/assets/icon/star_s@3x.png 3x"
}
const _hoisted_8 = {
  key: 1,
  class: "star",
  src: "/assets/icon/star_n.png",
  srcset: "/assets/icon/star_n@2x.png 2x,/assets/icon/star_n@3x.png 3x"
}
const _hoisted_9 = {
  class: "ion-activatable ripple-parent",
  onclick: "location.href='/tabs/home'"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "top_home",
  src: "/assets/icon/home.png",
  srcset: "/assets/icon/home@2x.png 2x,/assets/icon/home@3x.png 3x"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-margin" }, null, -1))
const _hoisted_12 = {
  id: "company__topContainer",
  class: "top-container"
}
const _hoisted_13 = { class: "company-info" }
const _hoisted_14 = { class: "info-left" }
const _hoisted_15 = { class: "info-logo" }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_18 = { class: "info-right white" }
const _hoisted_19 = { class: "title_20B" }
const _hoisted_20 = { class: "value main_12R" }
const _hoisted_21 = { class: "green_score" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "gray_divide" }, "|", -1))
const _hoisted_23 = { class: "green-label" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "right_btn_w",
  src: "/assets/icon/btn_right_w.png",
  srcset: "/assets/icon/btn_right_w@2x.png 2x,/assets/icon/btn_right_w@3x.png 3x"
}, null, -1))
const _hoisted_25 = {
  id: "company__mainTab",
  class: "main-tab"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-title" }, " 구매하기 ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-title" }, " 팔기 ", -1))
const _hoisted_28 = ["src"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-title" }, " 토론 ", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-title" }, " 회사정보 ", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab_info" }, " 구매하기 ", -1))
const _hoisted_32 = { id: "company__buy_box" }
const _hoisted_33 = {
  key: 0,
  class: "card-clubdeal-container"
}
const _hoisted_34 = { class: "clubdeal_title" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 클럽딜 열기 ")
const _hoisted_36 = { class: "title_18R" }
const _hoisted_37 = { class: "slide_container" }
const _hoisted_38 = { class: "medium_card" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "card-mask" }
const _hoisted_41 = { class: "company-info" }
const _hoisted_42 = { class: "title_18B" }
const _hoisted_43 = { class: "card_info_wrap" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "row" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row-title" }, "가격", -1))
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { class: "strong" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_50 = {
  key: 1,
  class: "gray"
}
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "small" }
const _hoisted_53 = { class: "add-info" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "divide" }, "|")
], -1))
const _hoisted_55 = { class: "row_right" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = {
  key: 0,
  class: "heart_btn",
  src: "/assets/icon/heart_n_g.png",
  srcset: "/assets/icon/heart_n_g@2x.png 2x,/assets/icon/heart_n_g@3x.png 3x"
}
const _hoisted_58 = {
  key: 1,
  src: "/assets/icon/heart_s_g.png",
  class: "heart_btn",
  srcset: "/assets/icon/heart_s_g@2x.png 2x,/assets/icon/heart_s_g@3x.png 3x"
}
const _hoisted_59 = {
  key: 1,
  class: "card-clubdeal-container"
}
const _hoisted_60 = { class: "clubdeal_title" }
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" 진행 중 클럽딜 ")
const _hoisted_62 = { class: "title_18R" }
const _hoisted_63 = { class: "slide_container" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = { class: "medium_card" }
const _hoisted_66 = { class: "company-info" }
const _hoisted_67 = { class: "title_18B" }
const _hoisted_68 = { class: "card_info_wrap" }
const _hoisted_69 = { class: "medium_card_info" }
const _hoisted_70 = { class: "row" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row-title" }, "가격", -1))
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { class: "strong" }
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" 원")
const _hoisted_75 = {
  key: 1,
  class: "gray"
}
const _hoisted_76 = { class: "row" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row-title" }, "진행율", -1))
const _hoisted_78 = { class: "red" }
const _hoisted_79 = { class: "strong" }
const _hoisted_80 = /*#__PURE__*/_createTextVNode("%")
const _hoisted_81 = {
  key: 2,
  class: "card-clubdeal-container"
}
const _hoisted_82 = { class: "clubdeal_title" }
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" 진행 예정 클럽딜 ")
const _hoisted_84 = { class: "title_18R" }
const _hoisted_85 = { class: "slide_container" }
const _hoisted_86 = { class: "deal-container" }
const _hoisted_87 = { class: "medium_card" }
const _hoisted_88 = ["onClick"]
const _hoisted_89 = { class: "company-info" }
const _hoisted_90 = { class: "title_18B" }
const _hoisted_91 = { class: "card_info_wrap" }
const _hoisted_92 = ["onClick"]
const _hoisted_93 = { class: "row" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row-title" }, "가격", -1))
const _hoisted_95 = { key: 0 }
const _hoisted_96 = { class: "strong" }
const _hoisted_97 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_98 = {
  key: 1,
  class: "gray"
}
const _hoisted_99 = { class: "row" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row-title" }, "오픈", -1))
const _hoisted_101 = { class: "row_right" }
const _hoisted_102 = ["onClick"]
const _hoisted_103 = {
  key: 0,
  class: "heart_btn",
  src: "/assets/icon/heart_n_g.png",
  srcset: "/assets/icon/heart_n_g@2x.png 2x,/assets/icon/heart_n_g@3x.png 3x"
}
const _hoisted_104 = {
  key: 1,
  src: "/assets/icon/heart_s_g.png",
  class: "heart_btn",
  srcset: "/assets/icon/heart_s_g@2x.png 2x,/assets/icon/heart_s_g@3x.png 3x"
}
const _hoisted_105 = {
  key: 3,
  class: "card-clubdeal-container"
}
const _hoisted_106 = { class: "clubdeal_title" }
const _hoisted_107 = /*#__PURE__*/_createTextVNode(" 마감된 클럽딜 ")
const _hoisted_108 = { class: "title_18R" }
const _hoisted_109 = { class: "slide_container" }
const _hoisted_110 = { class: "medium_card" }
const _hoisted_111 = { class: "company-info" }
const _hoisted_112 = { class: "title_18B" }
const _hoisted_113 = { class: "card_info_wrap" }
const _hoisted_114 = { class: "medium_card_info" }
const _hoisted_115 = { class: "row" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row-title" }, "가격", -1))
const _hoisted_117 = { class: "strong" }
const _hoisted_118 = /*#__PURE__*/_createTextVNode(" 원")
const _hoisted_119 = { class: "row" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row-title" }, "오픈", -1))
const _hoisted_121 = { class: "row_right" }
const _hoisted_122 = { class: "right_wrap" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/heart_s_g.png",
  class: "heart_btn",
  srcset: "/assets/icon/heart_s_g@2x.png 2x,/assets/icon/heart_s_g@3x.png 3x"
}, null, -1))
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dimmed_bg" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/icon/icon_close.png",
      srcset: "/assets/icon/icon_close@2x.png 2x, /assets/icon/icon_close@3x.png 3x",
      class: ""
    }),
    /*#__PURE__*/_createElementVNode("p", null, "클럽딜 마감")
  ])
], -1))
const _hoisted_125 = {
  key: 4,
  class: "other-clubdeal-container"
}
const _hoisted_126 = { class: "clubdeal_title space-between" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "다른회사 클럽딜 ", -1))
const _hoisted_128 = { class: "title_18R" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "더보기", -1))
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "right_btn",
  src: "/assets/icon/btn_right.png",
  srcset: "/assets/icon/btn_right@2x.png 2x,/assets/icon/btn_right@3x.png 3x"
}, null, -1))
const _hoisted_131 = { class: "clubdeal-badge" }
const _hoisted_132 = { class: "logo" }
const _hoisted_133 = ["src"]
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_135 = { class: "collecting" }
const _hoisted_136 = { class: "pre-regist" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/image/spankle.png",
  srcset: "/assets/image/spankle@2x.png 2x,/assets/image/spankle@3x.png 3x"
}, null, -1))
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "조합지분 거래 사전신청"),
  /*#__PURE__*/_createTextVNode("하고"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "가장 먼저"),
  /*#__PURE__*/_createTextVNode(" 경험해보세요 ")
], -1))
const _hoisted_139 = { class: "sell_btn_container" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_text" }, " 사전신청하면 1개월 거래수수료 무료 ", -1))
const _hoisted_141 = /*#__PURE__*/_createTextVNode(" 사전 신청하기 ")
const _hoisted_142 = { id: "company__sell_box" }
const _hoisted_143 = { class: "sell_container" }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab_info" }, " 팔기 ", -1))
const _hoisted_145 = { class: "sell_btn_container disabled" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_text" }, " 참여하신 조합의 지분 거래가 곧 가능해져요! ", -1))
const _hoisted_147 = /*#__PURE__*/_createTextVNode(" 이 회사 조합지분 거래 사전신청 ")
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sell_btn_container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "info_text" }, " 보유주식 팔면 수수료 0원, 100,000P 적립 "),
  /*#__PURE__*/_createTextVNode(" 기 ")
], -1))
const _hoisted_149 = {
  key: 0,
  class: "stock_container"
}
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title_18B" }, "이 회사 주식 매물 ", -1))
const _hoisted_151 = { class: "title_18R" }
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stock_info" }, " 최저가로 등록된 매물이 먼저 매매됩니다. ", -1))
const _hoisted_153 = ["onClick"]
const _hoisted_154 = { class: "user_id" }
const _hoisted_155 = /*#__PURE__*/_createTextVNode(" 로그인 후 확인 ")
const _hoisted_156 = { class: "stock_status" }
const _hoisted_157 = { id: "company__board_box" }
const _hoisted_158 = { class: "board_container" }
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "board_tab_info" }, " 토론 ", -1))
const _hoisted_160 = {
  key: 0,
  class: "write_box"
}
const _hoisted_161 = /*#__PURE__*/_createTextVNode(" 이 회사 어떤가요? ")
const _hoisted_162 = /*#__PURE__*/_createTextVNode(" 의견 작성하기 ")
const _hoisted_163 = {
  key: 1,
  class: "write_box light"
}
const _hoisted_164 = /*#__PURE__*/_createTextVNode(" 의견을 작성하시려면 ")
const _hoisted_165 = /*#__PURE__*/_createTextVNode(" 로그인> ")
const _hoisted_166 = { class: "board_list_container" }
const _hoisted_167 = { id: "info_box" }
const _hoisted_168 = { class: "info_container" }
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab_info" }, " 회사정보 ", -1))
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "뉴스")
], -1))
const _hoisted_171 = ["onClick"]
const _hoisted_172 = { class: "info_container" }
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "회사소개")
], -1))
const _hoisted_174 = ["innerHTML"]
const _hoisted_175 = { class: "news_list" }
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "회사명", -1))
const _hoisted_177 = { class: "news_list" }
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "대표이사", -1))
const _hoisted_179 = { class: "news_list" }
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "사업자번호", -1))
const _hoisted_181 = { class: "news_list" }
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "설립일", -1))
const _hoisted_183 = { class: "news_list" }
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "총 발행 주식수", -1))
const _hoisted_185 = { class: "info_container" }
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "투자정보")
], -1))
const _hoisted_187 = { class: "item_left" }
const _hoisted_188 = { class: "series" }
const _hoisted_189 = { class: "info_date gray" }
const _hoisted_190 = ["innerHTML"]
const _hoisted_191 = { class: "item_right" }
const _hoisted_192 = { class: "strong" }
const _hoisted_193 = { class: "info_container" }
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "공시자료")
], -1))
const _hoisted_195 = { class: "doc_left" }
const _hoisted_196 = { class: "info_date gray" }
const _hoisted_197 = ["onClick"]
const _hoisted_198 = { class: "doc_right" }
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_content" }, " 모든 정보는 참고 및 정보 제공을 위한 것으로, 투자 권유를 목적으로 하지 않습니다. 제공되는 정보는 공개된 자료를 바탕으로 한 것이나 오류가 있을 수 있습니다. 리드엔젤과 엔젤리그는 제공되는 정보의 정확성을 보장하지 않으며, 제공되는 정보를 바탕으로 한 조합 참여의 결과에 대하여 책임지지 않습니다. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_refresher = _resolveComponent("ag-refresher")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_star_rating_inline = _resolveComponent("star-rating-inline")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_board_list = _resolveComponent("board-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        id: "company__ionContent",
        fullscreen: "true",
        "scroll-events": true,
        onIonScroll: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleScroll($event.target)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_refresher, {
            slot: "fixed",
            onRefresh: _ctx.doRefresh
          }, null, 8, ["onRefresh"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: "ion-activatable ripple-parent btn-back",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.replace('/tabs/search')))
                }, [
                  _hoisted_4,
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ]),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.stockItemName), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "ion-activatable ripple-parent",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.itemLike(_ctx.stockItemInfo.stockItemId)))
                }, [
                  (_ctx.stockItemInfo.likeFlag == true)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                    : (_openBlock(), _createElementBlock("img", _hoisted_8)),
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ])
              ])
            ])
          ]),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              class: "main-center",
              style: _normalizeStyle({ 'background-color': _ctx.stockItemInfo.bgColor, 'color' : _ctx.stockItemInfo.fontColor })
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("img", {
                      class: "img-circle img-responsive",
                      src: _ctx.stockItemInfo.companyLogo,
                      alt: "logo"
                    }, null, 8, _hoisted_16),
                    _hoisted_17
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.stockItemInfo.stockItemName), 1),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", null, "추정기업가치 " + _toDisplayString(_ctx.filter.numberToKorean(_ctx.stockItemInfo.currentValuation)) + "원", 1),
                    _createElementVNode("img", {
                      src: "/assets/icon/help-circle.png",
                      srcset: "/assets/icon/help-circle@2x.png 2x,/assets/icon/help-circle@3x.png 3x",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openPopover && _ctx.openPopover(...args)))
                    })
                  ]),
                  _createElementVNode("div", {
                    class: "right-bottom main_14R",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ([_ctx.changeTab('board'), _ctx.clickTab('board')]))
                  }, [
                    _createVNode(_component_star_rating_inline, {
                      class: "inline",
                      value: _ctx.stockItemInfo.avgPoint
                    }, null, 8, ["value"]),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(Number(_ctx.stockItemInfo.avgPoint).toFixed(1)), 1),
                    _hoisted_22,
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.stockItemInfo.count) + "명", 1),
                    _hoisted_24
                  ])
                ])
              ])
            ], 4)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", {
              class: _normalizeClass(["ion-activatable ripple-parent", [_ctx.activeTab === 'buy' ? 'select' : '']]),
              onClick: _cache[4] || (_cache[4] = ($event: any) => ([_ctx.changeTab('buy'), _ctx.clickTab('buy')]))
            }, [
              _hoisted_26,
              _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["ion-activatable ripple-parent", [_ctx.activeTab === 'sell' ? 'select' : '']]),
              onClick: _cache[5] || (_cache[5] = ($event: any) => ([_ctx.changeTab('sell'), _ctx.clickTab('sell')]))
            }, [
              _hoisted_27,
              _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["ion-activatable ripple-parent", [_ctx.activeTab === 'board' ? 'select' : '']]),
              onClick: _cache[6] || (_cache[6] = ($event: any) => ([_ctx.changeTab('board'), _ctx.clickTab('board')]))
            }, [
              _createElementVNode("img", {
                class: "tab-icon",
                src: _ctx.budIcon,
                alt: "bud"
              }, null, 8, _hoisted_28),
              _hoisted_29,
              _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["ion-activatable ripple-parent", [_ctx.activeTab === 'info' ? 'select' : '']]),
              onClick: _cache[7] || (_cache[7] = ($event: any) => ([_ctx.changeTab('info'), _ctx.clickTab('info')]))
            }, [
              _hoisted_30,
              _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
            ], 2)
          ]),
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            (_ctx.preparePartnerships.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.preparePartnerships.length), 1)
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preparePartnerships, (deal, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: deal.partnershipId,
                        class: "slide_wrap"
                      }, [
                        _createElementVNode("div", {
                          class: "deal-container",
                          style: _normalizeStyle(_ctx.collectingPartnerships.length-1 === idx ? {'margin-right' : '20px'} : '')
                        }, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", {
                              class: "ion-activatable ripple-parent medium_card_bg",
                              style: _normalizeStyle([{backgroundImage : `url("${deal.cardBgUrl}")`}, {"color":"#fff"}]),
                              onClick: () => _ctx.router.push({name:'ClubDealOpen', params: {clubdeal_id: deal.partnershipId}, query: {from:'company'}})
                            }, [
                              _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("div", _hoisted_41, [
                                  _createElementVNode("div", _hoisted_42, _toDisplayString(deal.partnershipName) + "> ", 1)
                                ])
                              ]),
                              _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                            ], 12, _hoisted_39),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("div", {
                                class: "ion-activatable ripple-parent medium_card_info",
                                onClick: () => _ctx.router.push({name:'ClubDealOpen', params: {clubdeal_id: deal.partnershipId}, query: {from:'company'}})
                              }, [
                                _createElementVNode("div", _hoisted_45, [
                                  _hoisted_46,
                                  (_ctx.hasSession())
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                                        _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$filters.currency(deal.purchasePrice)), 1),
                                        _hoisted_49
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_50, " 로그인 후 확인 "))
                                ]),
                                _createElementVNode("div", _hoisted_51, [
                                  _createElementVNode("div", _hoisted_52, [
                                    _createElementVNode("div", _hoisted_53, [
                                      _createElementVNode("span", null, _toDisplayString(deal.sellerInviteCode), 1),
                                      _hoisted_54,
                                      _createElementVNode("span", null, _toDisplayString(_ctx.filter.prettyDateToOnemonth(deal.updateAt, 'channel')), 1)
                                    ])
                                  ])
                                ]),
                                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                              ], 8, _hoisted_44),
                              _createElementVNode("div", _hoisted_55, [
                                _createElementVNode("div", {
                                  class: "ion-activatable ripple-parent right_wrap",
                                  onClick: ($event: any) => (_ctx.user === null ? _ctx.$global.openLoginModal() : _ctx.partnershipLike(deal.partnershipStatus, 'prepareDeals',deal.partnershipId))
                                }, [
                                  (deal.partnershipLikeId)
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_57))
                                    : (_openBlock(), _createElementBlock("img", _hoisted_58)),
                                  _createElementVNode("span", {
                                    class: _normalizeClass({'deep-blue':deal.partnershipLikeId>0, gray:!deal.partnershipLikeId})
                                  }, _toDisplayString(deal.likeCount), 3),
                                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                                ], 8, _hoisted_56)
                              ])
                            ])
                          ])
                        ], 4)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.collectingPartnerships.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _hoisted_61,
                    _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.collectingPartnerships.length), 1)
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collectingPartnerships, (deal, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: deal.partnershipId,
                        class: "slide_wrap"
                      }, [
                        _createElementVNode("div", {
                          class: "ion-activatable ripple-parent deal-container",
                          style: _normalizeStyle(_ctx.collectingPartnerships.length-1 === idx ? {'margin-right' : '20px'} : ''),
                          onClick: () =>_ctx.useClubDealProgressModal(deal.partnershipId)
                        }, [
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("div", {
                              class: "medium_card_bg",
                              style: _normalizeStyle([{backgroundImage : `url("${deal.cardBgUrl}")`}, {"color":"#fff"}])
                            }, [
                              _createElementVNode("div", _hoisted_66, [
                                _createElementVNode("div", _hoisted_67, _toDisplayString(deal.partnershipName) + "> ", 1)
                              ])
                            ], 4),
                            _createElementVNode("div", _hoisted_68, [
                              _createElementVNode("div", _hoisted_69, [
                                _createElementVNode("div", _hoisted_70, [
                                  _hoisted_71,
                                  (_ctx.hasSession())
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_72, [
                                        _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.$filters.currency(deal.purchasePrice)), 1),
                                        _hoisted_74
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_75, "로그인 후 확인"))
                                ]),
                                _createElementVNode("div", _hoisted_76, [
                                  _hoisted_77,
                                  _createElementVNode("span", _hoisted_78, [
                                    _createElementVNode("span", _hoisted_79, _toDisplayString(deal.collectedRate*100), 1),
                                    _hoisted_80
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                        ], 12, _hoisted_64)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.comingSoonPartnerships.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                  _createElementVNode("div", _hoisted_82, [
                    _hoisted_83,
                    _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.comingSoonPartnerships.length), 1)
                  ]),
                  _createElementVNode("div", _hoisted_85, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comingSoonPartnerships, (deal) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: deal.partnershipId
                      }, [
                        _createElementVNode("div", _hoisted_86, [
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("div", {
                              class: "ion-activatable ripple-parent medium_card_bg",
                              style: _normalizeStyle([{backgroundImage : `url("${deal.cardBgUrl}")`}, {"color":"#fff"}]),
                              onClick: () => _ctx.router.push({name:'ClubDealProgress', params: {clubdeal_id: deal.partnershipId}})
                            }, [
                              _createElementVNode("div", _hoisted_89, [
                                _createElementVNode("div", _hoisted_90, _toDisplayString(deal.partnershipName) + " > ", 1)
                              ]),
                              _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                            ], 12, _hoisted_88),
                            _createElementVNode("div", _hoisted_91, [
                              _createElementVNode("div", {
                                class: "ion-activatable ripple-parent medium_card_info",
                                onClick: () => _ctx.router.push({name:'ClubDealProgress', params: {clubdeal_id: deal.partnershipId}})
                              }, [
                                _createElementVNode("div", _hoisted_93, [
                                  _hoisted_94,
                                  (_ctx.hasSession())
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_95, [
                                        _createElementVNode("span", _hoisted_96, _toDisplayString(_ctx.$filters.currency(deal.purchasePrice)), 1),
                                        _hoisted_97
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_98, " 로그인 후 확인 "))
                                ]),
                                _createElementVNode("div", _hoisted_99, [
                                  _hoisted_100,
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$filters.getMonthDay(deal.dueDateFrom)), 1)
                                ]),
                                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                              ], 8, _hoisted_92),
                              _createElementVNode("div", _hoisted_101, [
                                _createElementVNode("div", {
                                  class: "ion-activatable ripple-parent right_wrap",
                                  onClick: ($event: any) => (_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.partnershipLike(deal.partnershipStatus, 'prepareDeals',deal.partnershipId))
                                }, [
                                  (deal.partnershipLikeId)
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_103))
                                    : (_openBlock(), _createElementBlock("img", _hoisted_104)),
                                  _createElementVNode("span", {
                                    class: _normalizeClass({'deep-blue':deal.partnershipLikeId>0, gray:!deal.partnershipLikeId})
                                  }, _toDisplayString(deal.likeCount), 3),
                                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                                ], 8, _hoisted_102)
                              ])
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.stockItemPartnershipHistories.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                  _createElementVNode("div", _hoisted_106, [
                    _hoisted_107,
                    _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.stockItemPartnershipHistories.length), 1)
                  ]),
                  _createElementVNode("div", _hoisted_109, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockItemPartnershipHistories, (deal, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: deal.partnershipId,
                        class: "slide_wrap"
                      }, [
                        _createElementVNode("div", {
                          class: "deal-container",
                          style: _normalizeStyle(_ctx.collectingPartnerships.length-1 === idx ? {'margin-right' : '20px'} : '')
                        }, [
                          _createElementVNode("div", _hoisted_110, [
                            _createElementVNode("div", {
                              class: "medium_card_bg",
                              style: _normalizeStyle([{backgroundImage : `url("${deal.cardBgUrl}")`}, {"color":"#fff"}])
                            }, [
                              _createElementVNode("div", _hoisted_111, [
                                _createElementVNode("div", _hoisted_112, _toDisplayString(deal.partnershipName) + "> ", 1)
                              ])
                            ], 4),
                            _createElementVNode("div", _hoisted_113, [
                              _createElementVNode("div", _hoisted_114, [
                                _createElementVNode("div", _hoisted_115, [
                                  _hoisted_116,
                                  _createElementVNode("span", null, [
                                    _createElementVNode("span", _hoisted_117, _toDisplayString(_ctx.$filters.currency(deal.purchasePrice)), 1),
                                    _hoisted_118
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_119, [
                                  _hoisted_120,
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$filters.getMonthDay(deal.dueDateFrom)), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_121, [
                                _createElementVNode("div", _hoisted_122, [
                                  _hoisted_123,
                                  _createElementVNode("span", {
                                    class: _normalizeClass({'deep-blue':deal.partnershipLikeId>0, gray:!deal.partnershipLikeId})
                                  }, _toDisplayString(deal.likeCount), 3)
                                ])
                              ])
                            ]),
                            _hoisted_124
                          ])
                        ], 4)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.anotherCompanyPartnerships.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                  _createElementVNode("div", _hoisted_126, [
                    _createElementVNode("div", null, [
                      _hoisted_127,
                      _createElementVNode("span", _hoisted_128, _toDisplayString(_ctx.anotherCompanyPartnerships.length), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "ion-activatable ripple-parent add_btn margin-right",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.moreClubdeals && _ctx.moreClubdeals(...args)))
                    }, [
                      _hoisted_129,
                      _hoisted_130,
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_131, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.anotherCompanyPartnerships, (deal, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: deal.partnershipId,
                        class: "badge_wrap"
                      }, [
                        _createVNode(_component_router_link, {
                          to: {name:'ClubDealProgress', params: {clubdeal_id: deal.partnershipId}, query: {from:'company'}},
                          replace: ""
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "badge-container",
                              style: _normalizeStyle(_ctx.anotherCompanyPartnerships.length-1 === idx ? {'margin-right' : '20px'} : '')
                            }, [
                              _createElementVNode("div", {
                                class: "ion-activatable ripple-parent deal-badge",
                                style: _normalizeStyle({background:deal.bgColor, color:deal.fontColor})
                              }, [
                                _createElementVNode("div", _hoisted_132, [
                                  _createElementVNode("img", {
                                    src: deal.companyLogo,
                                    class: "img-circle img-responsive"
                                  }, null, 8, _hoisted_133),
                                  _hoisted_134
                                ]),
                                _createElementVNode("div", _hoisted_135, _toDisplayString(deal.partnershipName), 1),
                                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                              ], 4)
                            ], 4)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_136, [
              _hoisted_137,
              _hoisted_138,
              _createElementVNode("div", _hoisted_139, [
                _hoisted_140,
                _createElementVNode("div", {
                  class: "ion-activatable ripple-parent w_btn",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.preRegist && _ctx.preRegist(...args)))
                }, [
                  _hoisted_141,
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_142, [
            _createElementVNode("div", _hoisted_143, [
              _hoisted_144,
              _createElementVNode("div", _hoisted_145, [
                _hoisted_146,
                _createElementVNode("div", {
                  class: "ion-activatable ripple-parent w_btn",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.preRegist()))
                }, [
                  _hoisted_147,
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ])
              ]),
              _hoisted_148
            ]),
            (_ctx.diplayStockItemSell.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                  _createElementVNode("div", null, [
                    _hoisted_150,
                    _createElementVNode("span", _hoisted_151, _toDisplayString(_ctx.diplayStockItemSell.length) + "건", 1)
                  ]),
                  _hoisted_152,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diplayStockItemSell, (sell) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: sell.stockItemWantSellId,
                      class: "ion-activatable ripple-parent stock_item",
                      onClick: ($event: any) => (_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.showMySellItem(sell))
                    }, [
                      _createElementVNode("span", _hoisted_154, _toDisplayString(sell.inviteCode), 1),
                      _createElementVNode("span", {
                        class: "stock_price",
                        style: _normalizeStyle({textDecoration:(sell.isMine?'underline':'')})
                      }, [
                        (_ctx.hasSession())
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.$filters.currency(sell.sellPrice)) + " 원 / " + _toDisplayString(_ctx.$filters.currency(sell.qty)) + " 주 ", 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_155
                            ], 64))
                      ], 4),
                      _createElementVNode("span", _hoisted_156, _toDisplayString(sell.info.join(' · ')), 1),
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ], 8, _hoisted_153))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_157, [
            _createElementVNode("div", _hoisted_158, [
              _hoisted_159,
              (_ctx.hasSession())
                ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                    _hoisted_161,
                    _createElementVNode("div", {
                      class: "ion-activatable ripple-parent write_btn",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openModal({})))
                    }, [
                      _hoisted_162,
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_163, [
                    _hoisted_164,
                    _createElementVNode("div", {
                      class: "ion-activatable ripple-parent",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$global.openLoginModal()))
                    }, [
                      _hoisted_165,
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ])
                  ]))
            ]),
            _createElementVNode("div", _hoisted_166, [
              _createVNode(_component_board_list, { "stock-item-id": _ctx.paramsId }, null, 8, ["stock-item-id"])
            ])
          ]),
          _createElementVNode("div", _hoisted_167, [
            _createElementVNode("div", _hoisted_168, [
              _hoisted_169,
              _hoisted_170,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockItemInfo.press, (info, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: idx,
                  class: "news_list"
                }, [
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent",
                    onClick: ($event: any) => {_ctx.filter.openLink(info.link);}
                  }, [
                    _createTextVNode(_toDisplayString(info.title) + " ", 1),
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ], 8, _hoisted_171)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_172, [
              _hoisted_173,
              _createElementVNode("div", {
                class: "company_info",
                innerHTML: _ctx.stockItemInfo.companyIntroduction
              }, null, 8, _hoisted_174),
              _createElementVNode("div", _hoisted_175, [
                _hoisted_176,
                _createElementVNode("span", null, _toDisplayString(_ctx.stockItemInfo.stockItemName), 1)
              ]),
              _createElementVNode("div", _hoisted_177, [
                _hoisted_178,
                _createElementVNode("span", null, _toDisplayString(_ctx.stockItemInfo.ceo), 1)
              ]),
              _createElementVNode("div", _hoisted_179, [
                _hoisted_180,
                _createElementVNode("span", null, _toDisplayString(_ctx.stockItemInfo.bizno), 1)
              ]),
              _createElementVNode("div", _hoisted_181, [
                _hoisted_182,
                _createElementVNode("span", null, _toDisplayString(_ctx.stockItemInfo.foundDate), 1)
              ]),
              _createElementVNode("div", _hoisted_183, [
                _hoisted_184,
                _createElementVNode("span", null, _toDisplayString(_ctx.$filters.currency(_ctx.stockItemInfo.totalStockAmount)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_185, [
              _hoisted_186,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockItemInfo.investHistory, (info, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: idx,
                  class: "news_list space-between"
                }, [
                  _createElementVNode("div", _hoisted_187, [
                    _createElementVNode("div", _hoisted_188, _toDisplayString(info.series), 1),
                    _createElementVNode("div", _hoisted_189, _toDisplayString(info.date), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "item_center",
                    innerHTML: info.investor.split('|').map((i)=>{return `<span>${i}</span>`}).join('<br/>')
                  }, null, 8, _hoisted_190),
                  _createElementVNode("div", _hoisted_191, [
                    _createElementVNode("span", _hoisted_192, _toDisplayString(info.value), 1)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_193, [
              _hoisted_194,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockItemInfo.publicAnnouncement, (info, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: idx,
                  class: "news_list space-between"
                }, [
                  _createElementVNode("div", _hoisted_195, [
                    _createElementVNode("span", _hoisted_196, _toDisplayString(info.date), 1),
                    _createElementVNode("span", {
                      class: "ion-activatable ripple-parent info_link",
                      onClick: ($event: any) => (_ctx.filter.openLink(info.link))
                    }, [
                      _createTextVNode(_toDisplayString(info.title) + " ", 1),
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ], 8, _hoisted_197)
                  ]),
                  _createElementVNode("div", _hoisted_198, _toDisplayString(info.sender), 1)
                ]))
              }), 128))
            ]),
            _hoisted_199
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}